module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/logo-small-e5811ad30b5fc26ddc9c6cba29f1ca25.png";